import { render, staticRenderFns } from "./Vue2LeafletMarkercluster.vue?vue&type=template&id=4c908e12"
import script from "./Vue2LeafletMarkercluster.vue?vue&type=script&lang=js"
export * from "./Vue2LeafletMarkercluster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports